import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import { below } from '../style/functions'



const Col = ({ background, center, className, children, color, fit, full, maxHeight, minWidth, padded, style }) => (
  <ColWrapper className={classNames({ [className]: !!className, center, col: true, fit, full, padded })} style={{ maxHeight, minWidth, background, color, ...style }}>
    {children}
  </ColWrapper>
)

const ColWrapper = styled.div`
  flex: 1 0;

  &.center {
    display: flex;
    align-items: center;
    justify-content: center ;

    > * {
      flex: 1 0;
    }
  }

  ${below.tablet`
    min-width: 100%;
    flex: 1 0 auto;
  `}

  &.fit { width: 100%; }
  &.fit > * { object-fit: cover; height: 100%; width: 100%; }
  &.full { flex: 0 0 100%; }
  &.padded { padding: 4em; }
`

Col.propTypes = {
  background: PropTypes.string,
  color: PropTypes.string
}


Col.defaultProps = {
  style: {}
}



export default Col
